/* Hero Slideshow — juniorito.de */
(function () {
  'use strict';

  var instances = new WeakMap();

  function init(root) {
    if (!root || instances.has(root)) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-slideshow__slide'));
    if (slides.length === 0) return;

    // Fallback für Browser ohne :has()-Support — markiere den Viewport,
    // wenn mindestens ein Slide das "Text unter Bild"-Layout nutzt.
    var viewport = root.querySelector('.hero-slideshow__viewport');
    if (viewport && root.querySelector('[data-mobile-layout="below"]')) {
      viewport.classList.add('has-below-slide');
    }

    var track = root.querySelector('.hero-slideshow__track');
    var navItems = Array.prototype.slice.call(root.querySelectorAll('.hero-slideshow__nav-item'));
    var prevBtn = root.querySelector('.hero-slideshow__arrow--prev');
    var nextBtn = root.querySelector('.hero-slideshow__arrow--next');

    var autoplayEnabled = root.dataset.autoplay === 'true';
    var autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 6000;
    var pauseOnInteraction = root.dataset.pauseOnInteraction === 'true';
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var current = 0;
    var timer = null;
    var isVisible = true;

    function goTo(index) {
      if (index === current) return;
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');

      navItems.forEach(function (item, i) {
        // Hier ist aria-selected korrekt: Diese Buttons haben role="tab".
        item.setAttribute('aria-selected', i === current ? 'true' : 'false');
      });

      restartProgress();
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function restartProgress() {
      var activeFill = slides[current].querySelector
        ? null
        : null;
      var fills = root.querySelectorAll('.hero-slideshow__nav-fill');
      fills.forEach(function (fill) {
        fill.style.transition = 'none';
        fill.style.width = '0%';
      });
      var activeNavFill = navItems[current] && navItems[current].querySelector('.hero-slideshow__nav-fill');
      if (activeNavFill && autoplayEnabled && !reducedMotion) {
        requestAnimationFrame(function () {
          activeNavFill.style.transition = 'width ' + autoplaySpeed + 'ms linear';
          activeNavFill.style.width = '100%';
        });
      }
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length < 2 || reducedMotion) return;
      stopAutoplay();
      restartProgress();
      timer = setInterval(function () {
        if (isVisible) next();
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Nav clicks
    navItems.forEach(function (item, i) {
      item.addEventListener('click', function () {
        goTo(i);
        if (pauseOnInteraction) stopAutoplay();
        else startAutoplay();
      });
    });

    // Arrows
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        if (pauseOnInteraction) stopAutoplay();
        else startAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        if (pauseOnInteraction) stopAutoplay();
        else startAutoplay();
      });
    }

    // Keyboard navigation
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { next(); if (pauseOnInteraction) stopAutoplay(); }
      if (e.key === 'ArrowLeft') { prev(); if (pauseOnInteraction) stopAutoplay(); }
    });

    // Pause on hover / focus
    if (pauseOnInteraction) {
      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', startAutoplay);
    }

    // Touch swipe
    var touchStartX = 0;
    var touchEndX = 0;
    track.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      touchEndX = e.changedTouches[0].screenX;
      var delta = touchEndX - touchStartX;
      if (Math.abs(delta) > 40) {
        if (delta < 0) next(); else prev();
        if (pauseOnInteraction) stopAutoplay();
        else startAutoplay();
      }
    }, { passive: true });

    // Pause when scrolled out of view (perf + doesn't burn autoplay while unseen)
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isVisible = entry.isIntersecting;
        });
      }, { threshold: 0.25 });
      observer.observe(root);
    }

    // Hotspots: auf Touch-Geräten erster Tap öffnet die Karte, zweiter folgt dem Link
    var hotspots = Array.prototype.slice.call(root.querySelectorAll('.hero-slideshow__hotspot'));
    if (hotspots.length) {
      var isTouch = window.matchMedia('(hover: none)').matches;
      if (isTouch) {
        hotspots.forEach(function (spot) {
          spot.addEventListener('click', function (e) {
            if (!spot.classList.contains('is-open')) {
              e.preventDefault();
              hotspots.forEach(function (s) { s.classList.remove('is-open'); });
              spot.classList.add('is-open');
              if (pauseOnInteraction) stopAutoplay();
            }
          });
        });
        document.addEventListener('click', function (e) {
          if (!e.target.closest('.hero-slideshow__hotspot')) {
            hotspots.forEach(function (s) { s.classList.remove('is-open'); });
          }
        });
      }
    }

    startAutoplay();
    instances.set(root, { stopAutoplay: stopAutoplay });
  }

  function destroy(root) {
    var instance = instances.get(root);
    if (instance) {
      instance.stopAutoplay();
      instances.delete(root);
    }
  }

  // Eigenständiges Hotspot-Handling (z. B. für Shop the Look ohne Slideshow-Logik)
  function initHotspots(root) {
    if (!root) return;
    var isTouch = window.matchMedia('(hover: none)').matches;
    if (!isTouch) return;
    var hotspots = Array.prototype.slice.call(root.querySelectorAll('.stl__hotspot, .hero-slideshow__hotspot'));
    if (!hotspots.length) return;
    hotspots.forEach(function (spot) {
      spot.addEventListener('click', function (e) {
        if (!spot.classList.contains('is-open')) {
          e.preventDefault();
          hotspots.forEach(function (s) { s.classList.remove('is-open'); });
          spot.classList.add('is-open');
        }
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.stl__hotspot, .hero-slideshow__hotspot')) {
        hotspots.forEach(function (s) { s.classList.remove('is-open'); });
      }
    });
  }

  window.HeroSlideshow = { init: init, destroy: destroy, initHotspots: initHotspots };

  // Alle Hero-Slideshows auf der Seite initialisieren (idempotent durch WeakMap-Check)
  function initAll() {
    var roots = document.querySelectorAll('.hero-slideshow');
    Array.prototype.forEach.call(roots, function (root) { init(root); });
  }

  // Robust gegen jede Ladereihenfolge: sofort versuchen, plus auf DOM-ready.
  // (Bei defer kann DOMContentLoaded schon vorbei sein, wenn das Script laedt.)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme-Editor: Section neu geladen -> erneut initialisieren
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('.hero-slideshow') : null;
    if (root) init(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector ? event.target.querySelector('.hero-slideshow') : null;
    if (root) destroy(root);
  });
})();